import {useFragment} from 'react-relay'
import {graphql} from 'relay-runtime'
import type {MilestoneRow$key} from './__generated__/MilestoneRow.graphql'

type MilestoneRowProps = {
  milestone: MilestoneRow$key
}

export function MilestoneRow({milestone}: MilestoneRowProps) {
  const data = useFragment(
    graphql`
      fragment MilestoneRow on Milestone {
        title
      }
    `,
    milestone,
  )

  return <div>{data.title}</div>
}

try{ MilestoneRow.displayName ||= 'MilestoneRow' } catch {}